import Form from './form';

window.addEventListener('DOMContentLoaded', function(event) {
  Form(); 
});
